/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RecordRead } from "../../models/record-read";
import { RecordType } from "../../models/record-type";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadRecords$Params {
  organisation_id: string;
  zone_id: string;

  /**
   * The sort will accept parameters like `col` or `col:desc` and will split on the `:`. If it does not find a `:` it will sort ascending on that column. Sortable columns: id, zone_id, name, type, ttl, value, comment, is_active, is_locked
   */
  sort?: Array<string> | null;
  name?: string | null;
  record_type?: RecordType | null;
  ttl?: number | null;
  ttl_min?: number | null;
  ttl_max?: number | null;
  value?: string | null;
  comment?: string | null;
  is_active?: boolean | null;
  is_locked?: boolean | null;
  offset?: number;
  limit?: number;
}

export function readRecords(
  http: HttpClient,
  rootUrl: string,
  params: ReadRecords$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecordRead>>> {
  const rb = new RequestBuilder(rootUrl, readRecords.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("zone_id", params.zone_id, {});
    rb.query("sort", params.sort, {});
    rb.query("name", params.name, {});
    rb.query("record_type", params.record_type, {});
    rb.query("ttl", params.ttl, {});
    rb.query("ttl_min", params.ttl_min, {});
    rb.query("ttl_max", params.ttl_max, {});
    rb.query("value", params.value, {});
    rb.query("comment", params.comment, {});
    rb.query("is_active", params.is_active, {});
    rb.query("is_locked", params.is_locked, {});
    rb.query("offset", params.offset, {});
    rb.query("limit", params.limit, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecordRead>>;
    }),
  );
}

readRecords.PATH = "/surfdomeinen/organisations/{organisation_id}/zones/{zone_id}/records/";
